import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ifaCodesService } from './ifaCodes.service';
import { setAlertError } from '../alert/alert.slice';

const initialState = {
  ifaCodes: [],
  loading: false
};

export const getIfaCodes = createAsyncThunk('ifaCodes/getIfaCodes', async (_, thunkAPI) => {
  try {
    return await ifaCodesService.getIfaCodes();
  } catch (error) {
    const err = error.response?.data || { message: 'Failed to fetch IFA Codes.' };
    thunkAPI.dispatch(setAlertError(err.message));
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const ifaCodesSlice = createSlice({
  name: 'ifaCodes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getIfaCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getIfaCodes.fulfilled, (state, action) => {
        state.loading = false;
        state.ifaCodes = action.payload;
      })
      .addCase(getIfaCodes.rejected, (state) => {
        state.loading = false;
      });
  }
});

export default ifaCodesSlice.reducer;
